'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var googlish = function googlish(query) {
  var wholeWords = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  var caseSensitive = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

  var inquotes = /(["'])(\\\1|.)*?\1/g;
  var words = /[^\s"']+/g;
  var quoted = query.match(inquotes) || [];
  var rest = query.replace(inquotes, '').match(words) || [];
  var trim = function trim(s) {
    return s.substr(1, s.length - 2);
  };
  var dequoted = quoted.map(trim);
  var cs = caseSensitive ? '' : 'i';
  var wb = wholeWords ? '\\b' : '';
  var toRegExp = function toRegExp(word) {
    return new RegExp(wb + word + wb, cs);
  };
  var regExps = [].concat(_toConsumableArray(dequoted), _toConsumableArray(rest)).map(toRegExp);
  return function (text) {
    var i = 0;
    while (regExps[i] && regExps[i].test(text)) i++;
    return i === regExps.length;
  };
};

exports['default'] = googlish;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/googlish/lib/index.js
// module id = 146
// module chunks = 0 1